// extracted by mini-css-extract-plugin
export default {"root":"CSVUploader-root_qUlEx","text":"CSVUploader-text_LzUCW","isDragging":"CSVUploader-isDragging_qBH1m"};